var ToggleMovement = $.extend({/* ToggleMovement */}, BaseComponent, {

	componentSelector: '.movement',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).find('.movement-header').find('.more').click((function(event) {

			if ($(event.currentTarget).parents('.movements-period').length) { // Movement subitems listed within a period
				$(event.currentTarget).parents('.movements-period').find('.movement').removeClass('active');
				$(event.currentTarget).parents('.movement').addClass('active');
				$(event.currentTarget).parents('.movements-period').find('.movement').find('.less').removeClass('active');
				$(event.currentTarget).parents('.movements-content').find('.movement').find('.more').addClass('active');

				$(event.currentTarget).parents('.movements-content').find('.movements-period').find('.movement').removeClass('active');
				$(event.currentTarget).parents('.movement').addClass('active');

				$(event.currentTarget).parents('.movements-content').find('.movements-period').find('.movement').find('.movement-header-icon').find('.less').removeClass('active');
				$(event.currentTarget).parents('.movements-content').find('.movements-period').find('.movement').find('.movement-header-icon').find('.more').addClass('active');
		        $(event.currentTarget).removeClass('active');
		        $(event.currentTarget).parent('.movement-header-icon').find('.less').addClass('active');

		        Utils.scrollTo($(event.currentTarget).parents('.movement').offset().top);
	    	}
			else { // Movement items listed as search results
				$(event.currentTarget).parents('.movements-content').find('.movement').removeClass('active');
				$(event.currentTarget).parents('.movement').addClass('active');
				$(event.currentTarget).parents('.movements-content').find('.movement').find('.movement-header-icon').find('.less').removeClass('active');
				$(event.currentTarget).parents('.movements-content').find('.movement').find('.movement-header-icon').find('.more').addClass('active');

		        $(event.currentTarget).removeClass('active');
		        $(event.currentTarget).parent('.movement-header-icon').find('.less').addClass('active');

		        Utils.scrollTo($(event.currentTarget).parents('.movement').offset().top);
	    	}

		}).bind(this));

		$(element).find('.movement-header').find('.less').click((function(event) {

			if ($(event.currentTarget).parents('.movements-period').length) { // Movement subitems listed within a period
				$(event.currentTarget).parents('.movement').removeClass('active');
		        $(event.currentTarget).removeClass('active');
		        $(event.currentTarget).parent('.movement-header-icon').find('.more').addClass('active');

		        Utils.scrollTo($(event.currentTarget).parents('.movement').offset().top);
	    	}
			else { // Movement items listed as search results
				$(event.currentTarget).parents('.movement').removeClass('active');
		        $(event.currentTarget).removeClass('active');
		        $(event.currentTarget).parent('.movement-header-icon').find('.more').addClass('active');

		        Utils.scrollTo($(event.currentTarget).parents('.movement').offset().top);
	    	}

		}).bind(this));

	}
})
